// components/CurrentVacancies/VacancyCard.tsx
import React from "react";
import { Vacancy } from "./config/vacancyConfig";

const VacancyCard: React.FC<{ vacancy: Vacancy }> = ({ vacancy }) => {
  return (
    <div className="bg-white border rounded-lg shadow-sm p-4 w-64 shrink-0">
      <div className="flex items-center gap-2 mb-2">
        <div className={`w-6 h-6 rounded-full ${vacancy.color}`}></div>
        <h3 className="font-semibold text-sm">{vacancy.title}</h3>
      </div>
      <p className="text-xs text-gray-500 mb-3">{vacancy.ctc}</p>
      <div className="flex gap-2 mb-3">
        {vacancy.mode.map((m) => (
          <span
            key={m}
            className="text-xs bg-gray-100 px-3 py-1 rounded-full text-gray-500"
          >
            {m}
          </span>
        ))}
      </div>
      <div className="flex justify-between text-xs text-gray-500">
        <span>Openings: {vacancy.openings}</span>
        <span className="text-blue-600 font-medium cursor-pointer">
          Applications: {vacancy.applications}
        </span>
      </div>
    </div>
  );
};

export default VacancyCard;
